import { useState } from "react";
import { useSelector } from "react-redux";
import { userRequest } from "../../requestMethods";
import "./changePassword.css";

export default function ChangePassword() {
    const currentUser = useSelector((state) => state.user.currentUser);
    const [inputs, setInputs] = useState({
        currentPassword: "",
        newPassword: "",
        confirmPassword: "",
    });
    const [error, setError] = useState("");
    const [success, setSuccess] = useState("");
    const [loading, setLoading] = useState(false);

    const handleChange = (e) => {
        setInputs((prev) => ({
            ...prev,
            [e.target.name]: e.target.value,
        }));
        setError("");
        setSuccess("");
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError("");
        setSuccess("");
        setLoading(true);

        // Validation
        if (!inputs.currentPassword || !inputs.newPassword || !inputs.confirmPassword) {
            setError("All fields are required");
            setLoading(false);
            return;
        }

        if (inputs.newPassword.length < 6) {
            setError("New password must be at least 6 characters long");
            setLoading(false);
            return;
        }

        if (inputs.newPassword !== inputs.confirmPassword) {
            setError("New password and confirm password do not match");
            setLoading(false);
            return;
        }

        if (inputs.currentPassword === inputs.newPassword) {
            setError("New password must be different from current password");
            setLoading(false);
            return;
        }

        try {
            const res = await userRequest.post("/auth/changepassword", {
                userId: currentUser._id,
                currentPassword: inputs.currentPassword,
                newPassword: inputs.newPassword,
            });

            if (res.data) {
                setSuccess("Password changed successfully!");
                setInputs({
                    currentPassword: "",
                    newPassword: "",
                    confirmPassword: "",
                });
                setTimeout(() => {
                    setSuccess("");
                }, 5000);
            }
        } catch (err) {
            setError(err.response?.data?.error || "Failed to change password. Please check your current password.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="changePasswordContainer">
            <div className="changePasswordCard">
                <h2 className="changePasswordTitle">Change Password</h2>
                <p className="changePasswordSubtitle">Update your account password</p>

                <form onSubmit={handleSubmit} className="changePasswordForm">
                    <div className="formGroup">
                        <label htmlFor="currentPassword">Current Password</label>
                        <input
                            type="password"
                            id="currentPassword"
                            name="currentPassword"
                            value={inputs.currentPassword}
                            onChange={handleChange}
                            placeholder="Enter current password"
                            required
                            className="formInput"
                        />
                    </div>

                    <div className="formGroup">
                        <label htmlFor="newPassword">New Password</label>
                        <input
                            type="password"
                            id="newPassword"
                            name="newPassword"
                            value={inputs.newPassword}
                            onChange={handleChange}
                            placeholder="Enter new password (min. 6 characters)"
                            required
                            minLength={6}
                            className="formInput"
                        />
                    </div>

                    <div className="formGroup">
                        <label htmlFor="confirmPassword">Confirm New Password</label>
                        <input
                            type="password"
                            id="confirmPassword"
                            name="confirmPassword"
                            value={inputs.confirmPassword}
                            onChange={handleChange}
                            placeholder="Confirm new password"
                            required
                            className="formInput"
                        />
                    </div>

                    {error && <div className="errorMessage">{error}</div>}
                    {success && <div className="successMessage">{success}</div>}

                    <button
                        type="submit"
                        className="submitButton"
                        disabled={loading}
                    >
                        {loading ? "Changing Password..." : "Change Password"}
                    </button>
                </form>
            </div>
        </div>
    );
}
